<h5 mat-dialog-title class="pb-0">{{data.header}}</h5>
<hr class="p-0 m-0">
<mat-dialog-content class="mat-typography">
    <div class="m-2 p-2" [innerHTML]="data.content"></div>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <ng-container *ngIf="data.isConfirm; else defaultAction">
        <button mat-button (click)="closeDialog(false)">No</button>
        <button mat-raised-button color="primary" (click)="closeDialog(true)">Yes</button>
    </ng-container>

    <ng-template #defaultAction>
        <button mat-button (click)="closeDialog(true)">Close</button>
    </ng-template>
</mat-dialog-actions>